export default __webpack_public_path__ + "static/media/PlayStr.f52c0625.png";